import {extendBeatlesAPI} from './extendApi';

export function initBeatles(DDBridge) {
  extendBeatlesAPI(DDBridge);
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/index.js